import { render, staticRenderFns } from "./DeleteGenreInTwoSteps.vue?vue&type=template&id=0203b3c8&"
import script from "./DeleteGenreInTwoSteps.vue?vue&type=script&lang=js&"
export * from "./DeleteGenreInTwoSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports